import { ChangeDetectionStrategy, Component, HostBinding, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { Frac } from '~lmo/models/frac.model';
import { LmoFracFcpoService } from '~lmo/services/lmo-frac-fcpo.service';
import { LmoFracsService } from '~lmo/services/lmo-fracs.service';
import { RouterStateService } from '~services/router-state.service';
import { UserService } from '~services/user.service';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'sa-lmo-frac',
  styleUrls: ['./lmo-frac.component.scss'],
  templateUrl: './lmo-frac.component.html',
})
export class LmoFracComponent implements OnInit {
  @HostBinding('class') public className = 'flex-1 overflow-auto';
  public currentFrac$: Observable<Frac>;
  public hasFCPOAllocations$: Observable<boolean>;
  public onFracList$: Observable<boolean>;
  public isShaleApps = this.userService.isShaleappsEmail();

  constructor(
    private fracService: LmoFracsService,
    private userService: UserService,
    private fcpoService: LmoFracFcpoService,
    private routerStateService: RouterStateService,
  ) {}

  public ngOnInit() {
    this.currentFrac$ = this.fracService.currentFrac$;
    const fcpos$ = this.fcpoService.currentFracFcpos$;
    this.hasFCPOAllocations$ = fcpos$.pipe(
      filter((fcpos) => !!(fcpos || []).length),
      map((fcpos) => {
        return (fcpos || []).some((fcpo) => !!fcpo.percentBasedAutoOrderingAllocation);
      }),
    );
    this.onFracList$ = this.routerStateService.routerState$.pipe(
      map((state) => {
        return state.url === '/lmo/frac/list';
      }),
    );
  }
}
